export const getTimezoneString = () => (Intl.DateTimeFormat().resolvedOptions().timeZone)